import { render, staticRenderFns } from "./videoComponents.vue?vue&type=template&id=001ba1b4&scoped=true"
import script from "./videoComponents.vue?vue&type=script&lang=js"
export * from "./videoComponents.vue?vue&type=script&lang=js"
import style0 from "./videoComponents.vue?vue&type=style&index=0&id=001ba1b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001ba1b4",
  null
  
)

export default component.exports